import React, { useState } from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../user1000Aside";
import Button from 'components/buttons/';
import UIInputPW from 'components/input/inputPW';
import userStore from "common/user/store/UserStore";
import CommonUtil from 'utils/CommonUtil';
import UIUtils from "utils/UIUtils";
import userRepository from "common/user/repository/UserRepository";

function ContentsContainer() {
    const location = useLocation();
    const receivedData = (location.state as any)?.data;
    const history = useHistory();

    var loginId = sessionStorage.getItem("user");
    const [isChk,setIsChk] = useState(false);
    const [loginPassword ,setLoginPassword] = useState('');
    const loginForm = React.useRef<HTMLFormElement>(null);

    const formId = "loginForm";

    // SessionStorage 에서 아이디 출력
    //@ts-ignore
    var split = loginId.split('"');
    var userStr = JSON.stringify(split[5])
    var userName = userStr.replaceAll('"', '');

    const checkBoxHandler = (e) => {
        setIsChk(e.target.checked);
    };

    const alertModal = async () => {
        const value = await UIUtils.alert(<>
            필수 입력이 완료되지 않았습니다.<br/>
            다시 확인해 주세요.
        </>);
    }

    async function onClickCancel(event) {
        event.preventDefault();

        if(!isChk){
            UIUtils.alert('필수동의 체크를 완료해주세요').then();
            return false;
        }

        if(loginPassword === ""){
            alertModal();
            return false;
        }


        if(await UIUtils.confirm('탈퇴 하시겠습니까?')){

            const response:any = await CommonUtil.execute({
                url: "usr_1503.jct",
                form: loginForm.current as HTMLFormElement,
            }).then((response:any) => {
                if(response.ERR_CD =="9999"){
                    UIUtils.alert(response.ERR_MSG).then();
                    return;
                } else {
                    UIUtils.alert('탈퇴처리가 완료되었습니다.').then(() => {
                    }).then(() => {
                        userStore.logoutQuietly(false).then();
                    });;
                }
            }).catch((error) => {
                CommonUtil.showAxiosError(error);
                return;
            });

        }
    };

    const onClickPage = () => {
        history.push({
            pathname: '/',
        });
    };


	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/main/">홈</Link></li>
					<li><Link to="/main/usr_1000/usr_1500">마이페이지</Link></li>
					<li><Link to="#">회원탈퇴</Link></li>
				</ul>
				<main className="fww-main" data-layout="usr">
					<div className="mypage pw-edit">
						<h1 className="tx tx-hd2">회원탈퇴</h1>
						<div className="sub-tx">회원 탈퇴를 하기 전 , 다음 내용을 꼭 확인해 주세요.</div>
						<ul className="withdrawal mb15">
							<li>탈퇴 후, 회원님의 개인정보(핸드폰번호)가 삭제됩니다.<br />(과제관리를 위하여 담당자 성함, 회사전화, 회사이메일주소는 삭제되지 않습니다.)</li>
							<li>탈퇴한 아이디는 재사용 및 복구가 불가능하오니 이점 양지하여 주시기 바랍니다.</li>
						</ul>
						<label htmlFor="chk" className="hz-item ip-ch-label ip-ch-18 mb15">
							<input id="chk" className="ip-ch" type="checkbox" name={'isChk'} checked={isChk} onChange={(e) => checkBoxHandler(e)}/>
							<span className="check"></span>
							<span className="txt">안내사항을 모두 확인하였으며, 이에 동의합니다.</span>
						</label>
						<div className="withdrawal-info">
                            <div className="chk-id">
                                아이디 : <span className="fc-pri">{userName}</span>
                            </div>
                            <form id={formId} name={formId} ref={loginForm}>
                                <div className="find-pw" >
                                    <div className="form-items">
                                        <label className="mb15">비밀번호 입력</label>
                                        <UIInputPW
                                            className={'tf tf-big w100p'}
                                            placeholder={'비밀번호를 입력하세요'}
                                            attrs={{
                                                name: "LOGIN_PASSWORD",
                                                alt: "Password",
                                                tabIndex: 1,
                                                autoComplete: "on",
                                            }}
                                            readOnly={false}
                                            valueChanged={(value) => setLoginPassword(value)}
                                            rules={["required","password"]}
                                            focusClear={true}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
						<div className="hz-root hz-center hz-gap10 mt90">
							<Button color='gray-o' size="big" onClick={onClickPage}>취소</Button>
							<Button color='pri' size="big" onClick={onClickCancel}>탈퇴</Button>
						</div>
					</div>
				</main>
			</div>
		</PageContainer>
	);
}
export default ContentsContainer;